






































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ContactInformation } from '@/store/consumer-application/types';
import { requiredRule, characterCountRule, emailRule } from '@/form-rules';

@Component
export default class ContactInformationFields extends Vue {
  contact: ContactInformation = {
	emailAddress: '',
	mobilePhone: '',
	additionalPhone: ''
  };
  additionalPhoneChecked = false;

  data() {
	return {
		emailRules: [
			requiredRule('Email Address is required'),
			characterCountRule('Email Address', 50),
			emailRule()
		],
		mobilePhoneRules: [
			requiredRule('Mobile Phone is required')
		],
		additionalPhoneRules: [
			requiredRule('Additional Phone is required')
		]
	};
  }

  additionalPhoneClicked() {
	if (!this.additionalPhoneChecked) {
		this.contact.additionalPhone = '';
		this.updateContactInformation();
	}
  }

  updateContactInformation() {
	this.$store.commit(
		'consumerApplication/SET_CONTACT_INFORMATION_FIELDS',
		this.contact,
		{ root: true }
	);
  }
}
